import React from "react";
import "./payment.css";
import pay from "../../../../img/undraw_Mobile_pay_re_sjb8.png";
import { Container, Spinner, Table } from "react-bootstrap";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import notify from "../../../Notifcation";
import { useDispatch, useSelector } from "react-redux";
import {
  GetQouteSideAction,
  GetusersubsideAction,
  InsertusersubdashsideAction,
  UpdateQuteuserAction,
} from "../../../../redux/actions/UserSubscriptionAction";
import { ToastContainer } from "react-toastify";
const Payment = ({ userData }) => {
  const [Datee2, setDate2] = useState("");
  const [Datee1, setDate1] = useState("");
  const [val, setVal] = useState(0);
  // const [showDelete, setshowDelete] = useState(false);
  // const [showEdit, setshowEdit] = useState(false);
  const [Archivemega, setArchivemega] = useState(200);
  const [number, setnumber] = useState(false);
  const [moye, setmoye] = useState(0);
  const dispatch = useDispatch();
  const [Base64, setBase64] = useState("");
  const [File, setFile] = useState("");
  const [duration, setDuration] = useState("");
  const [Id, setId] = useState("");
  const [Isedit, setIsedit] = useState(false);
  const [loading, setLoading] = useState(true);
  const [Pricetotal, setPricetotal] = useState(0);
  const [isPress, setIsPress] = useState(false);
  const year = [1, 2, 3];
  const [Year, setYear] = useState("");
  const [NoteDescription, setNoteDescription] = useState("");
  const [Month, setMonth] = useState("");
  const [PriceOneGiga, setPriceOneGiga] = useState("");
  const { Createusersubside, Updatesqouteuser } = useSelector(
    (state) => state.UserSubscriptionR
  );

  const month = [6];
  const [foc, setfoc] = useState(false);
  // const handleCloseDelete = () => setshowDelete(false);
  // const handleShoweDelete = () => {
  //   setshowDelete(true);
  // };

  const AllQo = useSelector((state) => state.UserSubscriptionR.GetQoutside);

  const Mysubscribs = useSelector(
    (state) => state.UserSubscriptionR.Oneusersupside
  );

  useEffect(() => {
    dispatch(GetusersubsideAction());
  }, []);
  const handleGiga = (e) => {
    setArchivemega(e.target.value);
  };
  useEffect(() => {
    if (Archivemega === 200) {
      setPricetotal(0 * PriceOneGiga);
    }
    if (Archivemega === 1024) {
      setPricetotal(1 * PriceOneGiga);
    }
    if (Archivemega === 2048) {
      setPricetotal(2 * PriceOneGiga);
    }
    if (Archivemega === 3072) {
      setPricetotal(3 * PriceOneGiga);
    }
  }, [Archivemega]);
  function calculateDaysBetweenDatesLeft(date1, date2) {
    // Convert both dates to milliseconds
    if (date1 < date2) {
      var date1Ms = date1.getTime();
      var date2Ms = date2.getTime();

      // Calculate the difference in milliseconds
      var differenceMs = Math.abs(date1Ms - date2Ms);

      // Convert the difference in milliseconds to days
      var days = Math.ceil(differenceMs / (1000 * 60 * 60 * 24));
      return days;
    } else return 0;
  }

  function calculateDaysBetweenDates(date1, date2) {
    // Convert both dates to milliseconds
    var date1Ms = date1.getTime();
    var date2Ms = date2.getTime();

    // Calculate the difference in milliseconds
    var differenceMs = Math.abs(date1Ms - date2Ms);

    // Convert the difference in milliseconds to days
    var days = Math.floor(differenceMs / (1000 * 60 * 60 * 24));

    return days;
  }
  const getAll = async () => {
    await dispatch(GetQouteSideAction());
    setMonth(AllQo.pricePerMonth);
    setYear(AllQo.pricePerYear);
    setPriceOneGiga(AllQo.pricePerGB);
  };
  useEffect(() => {
    getAll();
  }, [moye]);
  useEffect(() => {
    setMonth(AllQo.pricePerMonth);
    setYear(AllQo.pricePerYear);
    setPriceOneGiga(AllQo.pricePerGB);
  }, []);
  useEffect(() => {
    // Fetch data every hour
    const timer = setTimeout(() => {
      window.location.reload();
    }, 1800000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (moye === 1) {
      // if (duration === 3) {
      //   const today = new Date();
      //   if (
      //     userData.SubscriptionType === "Paid-Subscription" ||
      //     userData.SubscriptionType === "Free-Subscription"
      //   ) {
      //     const lastdur = new Date(userData.subscriptionEndDate);
      //     const date1 = lastdur.toLocaleDateString("en-GB");
      //     const date2 = lastdur;
      //     date2.setMonth(date2.getMonth() + 3);
      //     const last = date2.toLocaleDateString("en-GB");
      //     setDate1(date1);
      //     setDate2(last);
      //     // setVal(3 * Month + Pricetotal * 3);
      //     setfoc(true);
      //   } else {
      //     const date1 = today.toLocaleDateString("en-GB");
      //     const date2 = today;
      //     date2.setMonth(date2.getMonth() + 3);
      //     const last = date2.toLocaleDateString("en-GB");
      //     setDate1(date1);
      //     setDate2(last);
      //     // setVal(3 * Month + Pricetotal * 3);
      //     setfoc(true);
      //   }
      // }
      if (duration === 6) {
        const today = new Date();
        if (
          userData.subscriptionType === "Paid-Subscription" ||
          userData.subscriptionType === "Free-Subscription"
        ) {
          const lastdur = new Date(userData.subscriptionEndDate);
          const date1 = lastdur.toLocaleDateString("en-GB");
          const date2 = lastdur;
          date2.setMonth(date2.getMonth() + 6);
          date2.toLocaleDateString("en-GB");
          const last = date2.toLocaleDateString("en-GB");
          setDate1(date1);
          setDate2(last);
          // setVal(6 * Month + Pricetotal * 6);
          setfoc(true);
        } else {
          const date1 = today.toLocaleDateString("en-GB");
          const date2 = today;
          date2.setMonth(date2.getMonth() + 6);
          date2.toLocaleDateString("en-GB");
          const last = date2.toLocaleDateString("en-GB");
          setDate1(date1);
          setDate2(last);
          // setVal(6 * Month + Pricetotal * 6);
          setfoc(true);
        }
      }
    } else if (moye === 2) {
      if (duration === 1) {
        const today = new Date();
        if (
          userData.subscriptionType === "Paid-Subscription" ||
          userData.subscriptionType === "Free-Subscription"
        ) {
          const lastdur = new Date(userData.subscriptionEndDate);
          const date1 = lastdur.toLocaleDateString("en-GB");
          const date2 = lastdur;
          date2.setFullYear(date2.getFullYear() + 1);
          const last = date2.toLocaleDateString("en-GB");
          setDate1(date1);
          setDate2(last);
          // setVal(Year + Pricetotal * 12);
          setfoc(true);
        } else {
          const date1 = today.toLocaleDateString("en-GB");
          const date2 = today;
          date2.setFullYear(date2.getFullYear() + 1);
          const last = date2.toLocaleDateString("en-GB");
          setDate1(date1);
          setDate2(last);
          // setVal(Year + Pricetotal * 12);
          setfoc(true);
        }
      }
      if (duration === 2) {
        const today = new Date();
        if (
          userData.subscriptionType === "Paid-Subscription" ||
          userData.subscriptionType === "Free-Subscription"
        ) {
          const lastdur = new Date(userData.subscriptionEndDate);
          const date1 = lastdur.toLocaleDateString("en-GB");
          const date2 = lastdur;
          date2.setFullYear(date2.getFullYear() + 2);
          date2.toLocaleDateString("en-GB");
          const last = date2.toLocaleDateString("en-GB");
          setDate1(date1);
          setDate2(last);
          // setVal(2 * Year + Pricetotal * 24);
          setfoc(true);
        } else {
          const date1 = today.toLocaleDateString("en-GB");
          const date2 = today;
          date2.setFullYear(date2.getFullYear() + 2);
          date2.toLocaleDateString("en-GB");
          const last = date2.toLocaleDateString("en-GB");
          setDate1(date1);
          setDate2(last);
          // setVal(2 * Year + Pricetotal * 24);
          setfoc(true);
        }
      }
      if (duration === 3) {
        const today = new Date();
        if (
          userData.subscriptionType === "Paid-Subscription" ||
          userData.subscriptionType === "Free-Subscription"
        ) {
          const lastdur = new Date(userData.subscriptionEndDate);
          const date1 = lastdur.toLocaleDateString("en-GB");
          const date2 = lastdur;
          date2.setFullYear(date2.getFullYear() + 3);
          date2.toLocaleDateString("en-GB");
          const last = date2.toLocaleDateString("en-GB");
          setDate1(date1);
          setDate2(last);
          // setVal(3 * Year + Pricetotal * 36);
          setfoc(true);
        } else {
          const date1 = today.toLocaleDateString("en-GB");
          const date2 = today;
          date2.setFullYear(date2.getFullYear() + 3);
          date2.toLocaleDateString("en-GB");
          const last = date2.toLocaleDateString("en-GB");
          setDate1(date1);
          setDate2(last);
          // setVal(3 * Year + Pricetotal * 36);
          setfoc(true);
        }
      }
    }
  }, [duration, moye]);
  const changedvavl = () => {
    if (moye === 1) {
      // if (duration === 3) {
      //   setVal(3 * Month + Pricetotal * 3);
      // } else
      if (duration === 6) {
        setVal(6 * Month + Pricetotal * 6);
      }
    } else if (moye === 2) {
      if (duration === 1) {
        setVal(Year + Pricetotal * 12);
        setfoc(true);
      } else if (duration === 2) {
        setVal(2 * Year + Pricetotal * 24);
        setfoc(true);
      } else if (duration === 3) {
        setVal(3 * Year + Pricetotal * 36);
        setfoc(true);
      }
    }
  };
  useEffect(() => {
    changedvavl();
  }, [duration, moye, Pricetotal]);
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (
  //     val === null ||
  //     Datee1 === null ||
  //     Datee2 === null ||
  //     Archivemega === null ||
  //     moye === null ||
  //     duration === null
  //   ) {
  //     notify("من فضلك اكمل البيانات المطلوبة", "warn");
  //     return;
  //   }

  //   // const formData = new FormData();
  //   // formData.append("from", Datee1);
  //   // formData.append("to", Datee2);
  //   // formData.append("subscriptionValue", val);
  //   // formData.append("File", File);

  //   setLoading(true);
  //   setIsPress(true);

  //   await dispatch(
  //     InsertemailtryAction({
  //       from: Datee1.split("/").reverse().join("-"),
  //       to: Datee2.split("/").reverse().join("-"),
  //       subscriptionValue: val,
  //       quoteName: "باقة اعمال النقدية",
  //       SubscriptionType: moye === 1 ? "شهر" : moye === 2 ? "سنة" : "",
  //       SubscriptionTypeCount: duration,
  //     })
  //   );
  //   await dispatch(GetusersubsideAction());
  //   setnumber((number) => !number);

  //   // await dispatch(GetAllFilesDetailsAction(`FileId=${id}`));
  //   // setTimeout(() => {
  //   //   window.location.reload(false);
  //   // }, 1500);
  //   // setTimeout(() => {
  //   //   window.location.reload();
  //   // }, 2000);
  //   // setDate('');
  //   // setTypeacc("");
  //   // setMainacc("");
  //   // setSubacc("");
  //   // setVal('');
  //   // setDesc('');
  //   // setBase64("");
  //   // setSelectedFile('');
  //   setLoading(false);
  //   setIsPress(false);
  // };
  const handleSubmitVrefy = async (e) => {
    e.preventDefault();
    if (
      val === null ||
      Datee1 === null ||
      Datee2 === null ||
      Archivemega === null ||
      moye === null ||
      duration === null
    ) {
      notify("من فضلك اكمل البيانات المطلوبة", "warn");
      return;
    }

    const formData = new FormData();
    formData.append("QuoteId", 3);
    formData.append("From", Datee1.split("/").reverse().join("/"));
    formData.append("To", Datee2.split("/").reverse().join("/"));
    formData.append("SubscriptionValue", val);
    formData.append("Note", NoteDescription);
    formData.append("SubscriptionSizeOnS3", Archivemega);
    formData.append("SubscriptionImage", File);
    formData.append("QuoteName", "باقة أعمال الموارد البشرية ");
    formData.append("SubscriptionTypeCount", duration);
    formData.append(
      "SubscriptionType",
      moye === 1 ? "شهر" : moye === 2 ? "سنة" : ""
    );

    setLoading(true);
    setIsPress(true);
    await dispatch(InsertusersubdashsideAction(formData));
    await dispatch(GetusersubsideAction());
    setLoading(false);
    setnumber((number) => !number);
    setIsPress(false);
  };
  function calculateDuration(startDate, endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);

    let years = end.getFullYear() - start.getFullYear();
    let months = end.getMonth() - start.getMonth();

    if (months < 0) {
      years--;
      months += 12;
    }

    return { years, months };
  }
  const updateitem = (itemsub) => {
    setfoc(true);
    const date1 = new Date(itemsub.from).toLocaleDateString("en-GB");
    const date2 = new Date(itemsub.to).toLocaleDateString("en-GB");
    const startDate = new Date(itemsub.from);
    const endDate = new Date(itemsub.to);
    const durationn = calculateDuration(startDate, endDate);
    setVal(itemsub.subscriptionValue);
    setDate1(date1);
    setId(itemsub.id);
    setIsedit(true);
    setDate2(date2);
    setArchivemega(itemsub.subscriptionSizeOnS3);
    setFile(itemsub.subscriptionFileUrl);
    if (durationn.months !== 0) {
      setmoye(1);
      // if (durationn.months === 3) {
      //   setDuration(3);
      // }
      if (durationn.months === 6) {
        setDuration(6);
      }
    } else if (durationn.years !== 0) {
      setmoye(2);
      if (durationn.years === 1) {
        setDuration(1);
      }
      if (durationn.years === 2) {
        setDuration(2);
      }
      if (durationn.years === 3) {
        setDuration(3);
      }
    }
    // setnumber((number) => !number);
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (
      val === null ||
      Datee1 === null ||
      Datee2 === null ||
      Archivemega === null ||
      moye === null ||
      duration === null
    ) {
      notify("من فضلك اكمل البيانات المطلوبة", "warn");
      return;
    }

    const formData = new FormData();
    formData.append("Id", Id);
    formData.append("From", Datee1.split("/").reverse().join("/"));
    formData.append("To", Datee2.split("/").reverse().join("/"));
    formData.append("Value", val);
    formData.append("Note", NoteDescription);
    formData.append("SubscriptionSizeOnS3", Archivemega);
    formData.append("SubscriptionImage", File);
    formData.append("QuoteName", "باقة أعمال الموارد البشرية ");
    formData.append("SubscriptionTypeCount", duration);
    formData.append(
      "SubscriptionType",
      moye === 1 ? "شهر" : moye === 2 ? "سنة" : ""
    );
    setLoading(true);
    setIsPress(true);
    await dispatch(UpdateQuteuserAction(formData));
    await dispatch(GetusersubsideAction());
    setLoading(false);
    setnumber((number) => !number);
    setIsPress(false);
    setIsedit(false);
  };
  function formatFileSize(bytes) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  }
  function importData() {
    let input = document.createElement("input");
    input.type = "file";
    input.multiple = "false";
    input.onchange = (e) => {
      setFile(e.target.files[0]);
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result;
        setBase64(base64);
      };

      reader.readAsDataURL(e.target.files[0]);
    };

    input.click();
  }

  const deleteFile = () => {
    setFile("");
    setBase64("");
  };
  useEffect(() => {
    if (loading === false) {
      // if (Very&Very.data) {
      //   if (
      //     Very.data.responseMessage ===
      //     "Great, you requested for subscription successfully"
      //   ) {
      //     notify("تم تأكيد الأشتراك بنجاح", "success");
      //   } else if (
      //     Very.data.responseMessage !==
      //     "Great, you requested for subscription successfully"
      //   ) {
      //     notify("حدثة مشكلة حاول مرة اخرى", "success");
      //   }
      // }
      if (Createusersubside) {
        if (
          Createusersubside.status === 200 ||
          Createusersubside.status === 201
        ) {
          if (Createusersubside.data) {
            if (
              Createusersubside.data.responseMessage ===
              "Great, you requested for subscription successfully"
            ) {
              notify("تم تأكيد الأشتراك بنجاح", "success");
            } else if (
              Createusersubside.data.responseMessage ===
              "You already have an active subscription"
            ) {
              notify("لديك اشتراك مفعل الأن", "warn");
            } else if (
              Createusersubside.data.responseMessage ===
              "You can't add more subscriptions request"
            ) {
              notify("لا يمكن أضافة اكثر من اشتراك غير مفعل", "warn");
            }
          }
        } else if (
          Createusersubside.status !== 200 ||
          Createusersubside.status !== 201
        ) {
          // if (res.data && res.data.responseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
      }
      if (Updatesqouteuser) {
        if (
          Updatesqouteuser.status === 200 ||
          Updatesqouteuser.status === 201
        ) {
          if (Updatesqouteuser.data) {
            if (
              Updatesqouteuser.data.responseMessage ===
              "Great, you updated the subscription successfully"
            ) {
              notify(
                "تم تعديل الأشتراك بنجاح سوف يتم تفعيلة قريباً",
                "success"
              );
            } else if (
              Updatesqouteuser.data.responseMessage ===
              "This is an active subscription if you want to update this one contact support"
            ) {
              notify("لديك اشتراك مفعل الأن للتحديث تواصل مع الأدمن", "warn");
            } else if (
              Updatesqouteuser.data.responseMessage ===
              "You can't add more subscriptions request"
            ) {
              notify("لا يمكن أضافة اكثر من اشتراك غير مفعل", "warn");
            }
          }
        } else if (
          Updatesqouteuser.status !== 200 ||
          Updatesqouteuser.status !== 201
        ) {
          // if (res.data && res.data.responseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
      }
    }
  }, [loading]);
  return (
    <>
      <Container>
        <div className="pay">
          {" "}
          <div className="container rounded bg-white mt-5 ">
            <div className="row">
              <h4 className="text-center">الأشتراكات</h4>
              <div className="col-md-6 border-right">
                <div className="p-3">
                  <div className="d-flex justify-content-between align-items-center "></div>
                  <div className="row mt-3 ">
                    <div className="col-md-12 de mb-2">
                      {" "}
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                          <Typography
                            sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                            اسم البرنامج
                            <span style={{ color: "red", fontSize: "19px" }}>
                              *
                            </span>
                          </Typography>
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          value={1}
                          label={
                            <Typography
                              sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                              اسم البرنامج
                              <span style={{ color: "red", fontSize: "19px" }}>
                                *
                              </span>
                            </Typography>
                          }>
                          <MenuItem value={1}>أعمال الموارد البشرية</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <div className="col-md-6 de  mb-2">
                      <FormControl fullWidth focused={foc}>
                        <InputLabel id="demo-simple-select-label">
                          {
                            <Typography
                              sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                              الاشتراك
                              <span style={{ color: "red", fontSize: "19px" }}>
                                *
                              </span>
                            </Typography>
                          }
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          value={moye}
                          onChange={(e) => setmoye(e.target.value)}
                          label={
                            <Typography
                              sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                              الاشتراك
                              <span style={{ color: "red", fontSize: "19px" }}>
                                *
                              </span>
                            </Typography>
                          }>
                          <MenuItem value={1}>شهر</MenuItem>
                          <MenuItem value={2}>سنة</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <div className="col-md-6 de  mb-2">
                      {" "}
                      <FormControl fullWidth focused={foc}>
                        <InputLabel id="demo-simple-select-label">
                          <Typography
                            sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                            {moye === 1
                              ? "عدد شهر "
                              : moye === 2
                              ? "عدد سنة"
                              : "عدد"}
                            <span style={{ color: "red", fontSize: "19px" }}>
                              *
                            </span>
                          </Typography>
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          value={duration}
                          onChange={(e) => setDuration(e.target.value)}
                          label={
                            <Typography
                              sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                              {moye === 1
                                ? "عدد شهر "
                                : moye === 2
                                ? "عدد سنة"
                                : "عدد"}
                              <span style={{ color: "red", fontSize: "19px" }}>
                                *
                              </span>
                            </Typography>
                          }>
                          {moye === 1
                            ? month.map((m, idx) => (
                                <MenuItem key={idx} value={m}>
                                  {m}
                                </MenuItem>
                              ))
                            : moye === 2
                            ? year.map((y, idx) => (
                                <MenuItem key={idx} value={y}>
                                  {y}
                                </MenuItem>
                              ))
                            : null}
                        </Select>
                      </FormControl>
                    </div>
                    <div className="col-md-6 ">
                      <div className="de  mb-2">
                        <TextField
                          focused={foc}
                          label={
                            <Typography
                              sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                              التاريخ من
                              <span style={{ color: "red", fontSize: "19px" }}>
                                *
                              </span>
                            </Typography>
                          }
                          className="ww"
                          variant="outlined"
                          type="text"
                          value={Datee1}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 ">
                      <div className="de  mb-2">
                        <TextField
                          focused={foc}
                          label={
                            <Typography
                              sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                              التاريخ إلى
                              <span style={{ color: "red", fontSize: "19px" }}>
                                *
                              </span>
                            </Typography>
                          }
                          variant="outlined"
                          className="ww"
                          type="text"
                          value={Datee2}
                        />
                      </div>
                    </div>

                    <div className="col-md-6 de  mb-2">
                      {" "}
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                          <Typography
                            sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                            الأرشيف
                            <span style={{ color: "red", fontSize: "19px" }}>
                              *
                            </span>
                          </Typography>
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          value={Archivemega}
                          onChange={handleGiga}
                          label={
                            <Typography
                              sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                              الأرشيف
                              <span style={{ color: "red", fontSize: "19px" }}>
                                *
                              </span>
                            </Typography>
                          }>
                          <MenuItem value={200}>200MB</MenuItem>
                          <MenuItem value={1024}>1GB</MenuItem>
                          <MenuItem value={2048}>2GB</MenuItem>
                          <MenuItem value={3072}>3GB</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <div className="col-md-6 de  mb-2 ">
                      <TextField
                        focused={foc}
                        value={val}
                        label={
                          <Typography
                            sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                            القيمة بالجنية المصري
                            <span style={{ color: "red", fontSize: "19px" }}>
                              *
                            </span>
                          </Typography>
                        }
                        variant="outlined"
                        className="ww"
                        type="number"
                        // value={5}
                      />
                    </div>
                    <div className="col-md-12  mb-2">
                      {" "}
                      <div className="infosub">
                        لتفعيل الاشتراك رجاء تحويل قيمة المبلغ {val} جنيه علي
                        حساب فودافون كاش او انستاباي علي رقم{" "}
                        <a
                          style={{ color: "blue" }}
                          href="https://wa.me/+201001122424">
                          01001122424
                        </a>{" "}
                        ورفع سكرين شوت بالتحويل من خلال الأتتش فايل او
                        علي رقم الواتساب!
                      </div>
                    </div>
                    <div className="col-md-6 ">
                      <div className="de  mb-2">
                        <TextField
                          label="رفع صورة التحويل"
                          variant="outlined"
                          inputProps={{ maxLength: 120 }}
                          type="text"
                          //   className="ww"
                          value={NoteDescription}
                          onChange={(e) => setNoteDescription(e.target.value)}
                        />
                        <i
                          onClick={importData}
                          className="ty fa-solid fa-paperclip"
                          style={{ color: "#1866ec" }}></i>
                      </div>
                      <div className="de">
                        {File && (
                          <div className="fi">
                            <a
                              href={Base64 ? Base64 : File}
                              target="blank"
                              download={File.name}>
                              {File.name ? (
                                File.name
                              ) : (
                                <i
                                  className=" fa-solid fa-paperclip"
                                  style={{ color: "#1866ec" }}></i>
                              )}
                            </a>
                            <div style={{ display: "block" }}>
                              {formatFileSize(File.size)
                                ? formatFileSize(File.size)
                                : null}
                            </div>
                            <button
                              style={{ background: "transparent" }}
                              className="buttonadd">
                              <i
                                onClick={(idx) => deleteFile(idx)}
                                className="fs fa-solid fa-trash-can icon-red"
                                style={{ color: "red" }}></i>
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="mt-5 text-center">
                    {/* <button
                      className={`profile-button wp ${number ? "dem" : ""}`}
                      onClick={handleSubmit}
                      disabled={number ? true : false}
                    >
                      أشتراك
                    </button> */}

                    {Isedit ? (
                      isPress && loading ? (
                        <button className="profile-button wp">
                          <Spinner animation="border" role="status"></Spinner>
                        </button>
                      ) : (
                        <button
                          onClick={handleUpdate}
                          className="profile-button wp">
                          تأكيد الأشتراك
                        </button>
                      )
                    ) : isPress && loading ? (
                      <button className="profile-button wp">
                        <Spinner animation="border" role="status"></Spinner>
                      </button>
                    ) : (
                      <button
                        onClick={handleSubmitVrefy}
                        className="profile-button wp">
                        اشترك
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <img src={pay} alt="" width={"100%"} />
              </div>
              {/* <div className="col-md-6">
                <Fade direction="left">
                  {number ? (
                    <>
                      <div className="infosub">
                        لتفعيل الاشتراك رجاء تحويل قيمة المبلغ {val} جنيه علي
                        حساب فودافون كاش رقم{" "}
                        <a
                          style={{ color: "blue" }}
                          href="https://wa.me/+201001122424"
                        >
                          01001122424
                        </a>{" "}
                        ورفع سكرين شوت بالتحويل من خلال الاتتش فايل او علي رقم
                        الواتساب!
                      </div>
                      <div className="inp-container pr">
                        <TextField
                          label="رفع صورة التحويل"
                          variant="outlined"
                          //   className="ww"
                          value={NoteDescription}
                          onChange={(e) => setNoteDescription(e.target.value)}
                        />
                        <i
                          onClick={importData}
                          className="ty fa-solid fa-paperclip"
                          style={{ color: "#1866ec" }}
                        ></i>
                      </div>
                      <div className="inp-container pr">
                        {File && (
                          <div className="fi">
                            <a
                              href={Base64 ? Base64 : File}
                              target="blank"
                              download={File.name}
                            >
                              {File.name ? (
                                File.name
                              ) : (
                                <i
                                  className=" fa-solid fa-paperclip"
                                  style={{ color: "#1866ec" }}
                                ></i>
                              )}
                            </a>
                            <div style={{ display: "block" }}>
                              {formatFileSize(File.size)
                                ? formatFileSize(File.size)
                                : null}
                            </div>
                            <button
                              style={{ background: "transparent" }}
                              className="buttonadd"
                            >
                              <i
                                onClick={(idx) => deleteFile(idx)}
                                className="fs fa-solid fa-trash-can icon-red"
                                style={{ color: "red" }}
                              ></i>
                            </button>
                          </div>
                        )}
                      </div>
                      {Isedit ? (
                        isPress && loading ? (
                          <button className="profile-button wp">
                            <Spinner animation="border" role="status"></Spinner>
                          </button>
                        ) : (
                          <button
                            onClick={handleUpdate}
                            className="profile-button wp"
                          >
                            تعديل الأشتراك
                          </button>
                        )
                      ) : isPress && loading ? (
                        <button className="profile-button wp">
                          <Spinner animation="border" role="status"></Spinner>
                        </button>
                      ) : (
                        <button
                          onClick={handleSubmitVrefy}
                          className="profile-button wp"
                        >
                          تأكيد الأشتراك
                        </button>
                      )}
                    </>
                  ) : null}
                </Fade>
              </div> */}
            </div>
          </div>
        </div>

        <Table responsive striped bordered hover>
          <thead>
            <tr>
              <th className="text-center">
                من<i className="fa-solid fa-calendar-days"></i>
              </th>
              <th className="text-center">
                إلى<i className="fa-solid fa-calendar-days"></i>
              </th>
              <th className="text-center">
                عدد الأيام <i className="fa-solid fa-calendar-check"></i>
              </th>
              <th className="text-center">
                عدد الأيام المتبقية{" "}
                <i className="fa-solid fa-calendar-check"></i>
              </th>
              <th>
                حالة الأشتراك <i className="fa-solid fa-file-import"></i>
              </th>
              {/* <th>
                مدفوع <i className="fa-solid fa-money-bill"></i>
              </th> */}
              <th>
                قيمة الأشتراك<i className="fa-solid fa-money-bills"></i>
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {Mysubscribs
              ? Mysubscribs.map((item, idx) => {
                  const date1 = new Date(item.from);
                  const date2 = new Date(item.to);
                  return (
                    <tr
                      key={idx}
                      onDoubleClick={async () => {
                        await updateitem(item);
                        updateitem(item);
                      }}>
                      <td>{date1.toLocaleDateString("en-GB")}</td>
                      <td>{date2.toLocaleDateString("en-GB")}</td>
                      <td>{calculateDaysBetweenDates(date1, date2)}</td>
                      <td>
                        {" "}
                        {calculateDaysBetweenDatesLeft(new Date(), date2)}
                      </td>

                      <td>{item.isActive === true ? "مفعل" : "غير مفعل"}</td>
                      {/* <td>{item.isPaid===true ? "مفعل"  : "غير مفعل"}</td> */}
                      <td>{item.subscriptionValue} جنيه</td>
                      <td>
                        {calculateDaysBetweenDates(date1, date2) !== 0 &&
                        item.isActive ===
                          true ? null : calculateDaysBetweenDates(
                            date1,
                            date2
                          ) !== 0 && item.isActive === false ? (
                          // <i
                          //   onClick={async () => {
                          //     await updateitem(item);
                          //     updateitem(item);
                          //   }}
                          //   className="fa fa-solid fa-pen-to-square icon-blue"
                          //   style={{ color: "rgb(0 44 146)" }}></i>
                          <button
                            onClick={async () => {
                              await updateitem(item);
                              updateitem(item);
                            }}
                            style={{ width: "73px" }}
                            className="profile-button wp">
                            تعديل
                          </button>
                        ) : (
                          <button
                            onClick={async () => {
                              await updateitem(item);
                              updateitem(item);
                            }}
                            style={{ width: "73px" }}
                            className="profile-button wp">
                            تجديد
                          </button>
                        )}
                      </td>
                      {/*  <td>
                {" "}
                <i
                  className="fs fa-solid fa-trash-can icon-red"
                 style={{ color: "red" }}
                ></i>
              </td> */}
                    </tr>
                  );
                })
              : null}
          </tbody>
        </Table>
      </Container>
      <ToastContainer autoClose={1200} />
    </>
  );
};

export default Payment;
